<template lang="pug">
.v-section-slider.section-slider(v-if="slider" )
	v-loader(:loading="loading")
	v-swiper-slider(v-if="slider.items && slider.items.length"
		@slideChange="slideChange"
		:options="{...options, freeMode: isSm, spaceBetween: computedSpaseBetween}"
		:navigation="navigation")
		swiper-slide.section-slider__slide(v-for="(item, index) in slider.items" :key="index")
			v-catalog-card.section-slider__catalog-card(v-if="slider.type === 'catalog'" :data-source="item")
			v-collection-lg-card(v-else-if="slider.type === 'collection-lg'" :data-source="item")
			v-property-card.section-slider__property-card(v-else-if="slider.type === 'property'" :data-source="item" @click="openGallery(index)")
			.section-slider__property-card(v-else @click="openGallery(index)")
				img.section-slider__image(v-if="item.src" :src="item.src" :alt="item?.alt")
</template>

<script>
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import breakpoints from '../scripts/breakpoints.js';
import uniqueId from '../scripts/helpers/uniqueId.js';
import {SwiperSlide} from "swiper/vue";

export default {
	mixins: [isMobMixin],
	components: {
		SwiperSlide,
	},

	emits: ['slide-change', 'open-gallery'],

	props: {
		slider: {
			type: Object,
			default: null
		},
		navigation: {
			type: [Boolean, Object],
			default: false
		}
	},


	data() {
		return {
			localSlider: null,
			loading: false,
			uniqueId: uniqueId('swiper-'),
			isMob: false,
			options: {
				slidesPerView: "auto",
				centeredSlides: "true",
				spaceBetween: this.computedSpaseBetween,
				a11y: {
					prevSlideMessage: 'Предыдущий слайд',
					nextSlideMessage: 'Следующий слайд',
				},
				breakpoints: {
					[breakpoints['lg-min']]: {
						slidesPerView: "auto"
					},
				}
			},
		};
	},

	methods: {
		slideChange(slider) {
			this.localSlider = slider;
			this.$emit('slide-change', slider)
		},

		openGallery(index) {
			this.$emit('open-gallery', {realIndex: index});
		}
	},

	computed: {
		computedSpaseBetween() {
			if (this.slider.type === 'property') {
				if(this.isSm) {
					return 30
				} else {
					return 100
				}
			} else {
				return 14
			}
		}
	}


};
</script>